import React from "react";
import { BrowserRouter as Router, Switch, Route, useHistory } from 'react-router-dom';
import './App.css';
import Footer from './function-components/Footer';
import Navbarmenu from './function-components/Navbarmenu';
import { MsalProvider } from "@azure/msal-react";
import { CustomNavigationClient } from "./utils/NavigationClient";
import Home from './pages/Home';
import { PageLayout } from "./function-components/PageLayout";
import Searchnav from "./function-components/Searchnav";

function App({ pca }) {
  const history = useHistory();
  const navigationClient = new CustomNavigationClient(history);

  pca.setNavigationClient(navigationClient);
  return (
    <MsalProvider instance={pca}>
      <PageLayout>
        <div container justifyContent="center">
          <Pages />
        </div>
       </PageLayout>
     </MsalProvider>
  );
}
function Pages() {    
    return (
      <>
        <Router>       
          <Searchnav />   
          <Navbarmenu />          
          <Switch>
            <Route exact path="/home">
              <Home />
            </Route>                        
            <Route exact path="/">
              <Home />
            </Route>            
          </Switch>
        </Router>        
        <Footer />
      </>
    );
}

export default App;
